import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import CursorIcon from "./CursorIcon";
import useMediaQuery from "../hooks/useMediaQuery";

/**
 * The frame shared by every page: header on top, page content below.
 * `<Outlet />` is where React Router puts the current page.
 */
export default function Layout() {
  const { pathname } = useLocation();
  // Pixel icons beside the pointer only make sense with a mouse
  const hasMouse = useMediaQuery("(hover: hover) and (pointer: fine)");

  // Start each new page at the top (browsers don't do this for client-side
  // navigation on their own).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="site">
      <SiteHeader />
      {/* `key` re-mounts <main> on navigation so the fade-in plays each time */}
      <main className="site-main page-enter" key={pathname}>
        <Outlet />
      </main>
      {hasMouse && <CursorIcon />}
    </div>
  );
}
